export default () => ({ legacy: true });
